import React from 'react'
import './Header.css'
import CTA from './CTA'
import Me from '../../assests/PICS.JPG'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    <header>
    <div className='container header__container'>

      <h5> Hello<span className='Heart__eyeEmoji'>👋👋</span> I'm</h5>

      <h1>Ike Daniel<span>🎊🎊</span> </h1>

      <h5 className='text-light'> Front-end developer</h5>

      <CTA />

      <HeaderSocials />

      <div className='personal__image'>
        <img src={Me} alt='Authors picture' className='image'/>
      </div> 

       <a href='#contact' className='scroll__down'>Scroll Down </a> 

    </div>
    </header>
  )
}

export default Header